import config from "../config";
import * as amplitude from "@amplitude/analytics-browser";

amplitude.init(config.services.amplitude.key);

export function logEvent(eventName, eventParams) {
  amplitude.logEvent(eventName, eventParams);
}